/**
 * Models page component
 */


import { Header } from '../components/layout/Header';
import ModelsTab from '../components/ModelsTab';

function ModelsPage() {
  return (
    <div className='min-h-screen bg-gray-50'>
      <Header />
      <main className='w-full py-6 sm:px-6 lg:px-8'>
        <div className='px-4 py-6 sm:px-0'>
          <ModelsTab />
        </div>
      </main>
    </div>
  );
}

export default ModelsPage;
